import {
  useQuery,
  useMutation,
  useQueryClient,
  keepPreviousData,
} from "@tanstack/react-query";
import { lotStatusService } from "../services/svc_invstatus";
import { queryKeys } from "../lib/queryKeys";
import { ListRequest } from "../types/common/commonTypes";

export const useTSQInvStatusList = (
  params: ListRequest,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: queryKeys.invstatus.list(params),
    queryFn: () => lotStatusService.list(params),
    placeholderData: keepPreviousData,
    enabled: enabled,
  });
};

export const useTSQInvStatus = (id: string) => {
  return useQuery({
    queryKey: queryKeys.invstatus.detail(id),
    queryFn: () => {
      return lotStatusService.getById(id);
    },
    enabled: !!id,
  });
};

export const useTSMCreateInvStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) => {
      return lotStatusService.create(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.invstatus.lists() });
    },
    onError: (error) => {
      console.error("Failed to create Status:", error);
    },
  });
};

export const useTSMUpdateInvStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: any }) => {
      return lotStatusService.update(id, data);
    },
    onSuccess: (updatedStatus) => {
      queryClient.setQueryData(
        queryKeys.invstatus.detail(updatedStatus.id),
        updatedStatus,
      );
      queryClient.invalidateQueries({ queryKey: queryKeys.invstatus.lists() });
    },
    onError: (error) => {
      console.error("Failed to update Status:", error);
    },
  });
};

export const useTSMDeactivateInvStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: lotStatusService.deactivate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.invstatus.lists() });
    },
    onError: (error) => {
      console.error("Failed to deactivate Status:", error);
    },
  });
};

export const useTSMReactivateInvStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: lotStatusService.reactivate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.invstatus.lists() });
    },
    onError: (error) => {
      console.error("Failed to reactivate Status:", error);
    },
  });
};
